import React from "react";
import CapitalUpdate from "./CapitalUpdatePassword";

const CapitalModalUpdate = ({ show, setShow }) => {
  if (!show) return null;

  return (
    <>
      {/* Backdrop */}
      <div
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.5)", // Semi-transparent background
          backdropFilter: "blur(10px)", // Apply blur effect
          zIndex: 1040,
        }}
      />

      {/* Modal */}
      <div
        role="dialog"
        aria-labelledby="capitalLoginTitle"
        style={{
          position: "fixed",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          zIndex: 9999,
          background: "#fff",
          borderRadius: "16px",
          padding: "2rem 2.5rem",
          width: "min(440px, 95vw)",
          boxShadow: "0 8px 40px rgba(0,0,0,0.25)",
        }}
      >
        <div
          onClick={() => {
            setShow(false);
          }}
          className="position-absolute"
          style={{
            top: "30px",
            right: "40px",
            cursor: "pointer",
            color: "red",
            fontSize: "18px",
          }}
        >
          <i className="fas fa-times"></i>
        </div>

        <div className="">
          <h3 className="text-warning mb-4">Update Credentials</h3>
          <CapitalUpdate
            onUpdated={() => {
              setShow(false);
            }}
          />
        </div>
      </div>
    </>
  );
};

export default CapitalModalUpdate;
